import { render, staticRenderFns } from "./guanlianhetong.vue?vue&type=template&id=5496434b&scoped=true&"
import script from "./guanlianhetong.vue?vue&type=script&lang=js&"
export * from "./guanlianhetong.vue?vue&type=script&lang=js&"
import style0 from "./guanlianhetong.vue?vue&type=style&index=0&id=5496434b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496434b",
  null
  
)

export default component.exports